import React from 'react';

// import _ from 'lodash';
import PropTypes from 'prop-types';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Actions from './Actions';
import { getFormattedDate } from '../utils/utils';
import { orderStatus } from '../utils/constant';
import { useTranslationsContext } from '../context/TranslationsContext';
import { GET_DEFECT_LOCALE } from './constants';
import { getMessage, getLastComment } from './utils';
const Row = ({ order, index, fetchOrders, setIsDelete }) => {
  const {
    WLS: {
      DASHBOARD: {
        Submitted,
        Incomplete,
        WirelessOrder,
        OrderType,
        PendingValidation,
        Canceled,
        WaitingOnSales,
        CanceledBySalesRep
      }
    },
    ORDERS: { filterByFlagsList }
  } = useTranslationsContext();

  const {
    wlsBusinessLegalName,
    status,
    updatedAt,
    createdAt,
    validatedAt,
    orderId,
    installationTypeWLS,
    isFlag = false,
    flag = ''
  } = order;
  const getStatusesMessage = () => {
    switch (status) {
      case orderStatus.validated:
        return Submitted;
      case orderStatus.pendingValidation:
        return PendingValidation;
      case orderStatus.canceled:
        return Canceled;
      case orderStatus.waitingOnSales:
        return WaitingOnSales;
      case orderStatus.canceledBySalesRep:
        return Canceled;
      default:
        return Incomplete;
    }
  };

  return (
    <Tr style={{ background: index % 2 === 0 ? '#f9f1ff' : '#ffffff' }}>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>{orderId}</Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {wlsBusinessLegalName || ''}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {GET_DEFECT_LOCALE(installationTypeWLS) || ''}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getFormattedDate(createdAt, 'YYYY-MM-DD') || '-'}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {validatedAt ? getFormattedDate(validatedAt, 'YYYY-MM-DD') : '-'}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getFormattedDate(updatedAt, 'YYYY-MM-DD') || '-'}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {getStatusesMessage()}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <div className="responsive-table__comment">
          {getLastComment(_.get(order, 'comments.0.text', '-'))}
        </div>
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        {flag ? getMessage(flag + '') : ''}
      </Td>
      <Td style={{ borderRight: '1px solid #e7e7e7' }}>
        <Actions
          status={status || orderStatus.incomplete}
          order={order}
          fetchOrders={fetchOrders}
          setIsDelete={setIsDelete}
        />
      </Td>
    </Tr>
  );
};

Row.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  index: PropTypes.number.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Row;
